import "./index.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Button, Modal } from "@/ui-kit";
import { type ICompanyChangeRequest } from "@/types/company-change-request";
import type { ILender } from "@/types/companies-lenders";
import type { IContractingCompany } from "@/types/companies-contractors";
import { useCompanyDetails } from "@/hooks/useCompanyDetails";
import { ChangeCompanyDetails } from "@/components/ChangeCompany/ChangeCompanyDetails";

type IProps = {
  companyType: "contractor" | "lender";
  currentCompany: ILender | IContractingCompany;
  request: ICompanyChangeRequest;
  onDismiss: () => void;
};

export const ChangeCompanyFormUser = ({
  companyType,
  request,
  currentCompany,
  onDismiss,
}: IProps) => {
  const { t } = useTranslation();

  const {
    data: newCompany,
    loading: newCompanyLoading,
    getCompanyDetails: getNewCompanyDetails,
  } = useCompanyDetails();

  useEffect(() => {
    if (!request.requestedCompanyId) {
      return;
    }

    void getNewCompanyDetails({
      id: request.requestedCompanyId,
      companyType,
    });
  }, [companyType, getNewCompanyDetails, request.requestedCompanyId]);

  return (
    <Modal
      open={true}
      onOpenChange={onDismiss}
      title={t("label.changeCompany.label")}
      footer={
        <>
          <Button onClick={onDismiss} variant="ghost" color="layer1">
            {t("action.done")}
          </Button>
        </>
      }
      className="change-company__modal"
    >
      <ChangeCompanyDetails
        request={request}
        currentCompany={currentCompany}
        newCompany={newCompany}
        newCompanyLoading={newCompanyLoading}
      />
    </Modal>
  );
};
